import { render, staticRenderFns } from "./DetailBooking.vue?vue&type=template&id=0918ec2a&scoped=true&"
import script from "./DetailBooking.vue?vue&type=script&lang=js&"
export * from "./DetailBooking.vue?vue&type=script&lang=js&"
import style0 from "./DetailBooking.vue?vue&type=style&index=0&id=0918ec2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0918ec2a",
  null
  
)

export default component.exports